// 선택된 템플릿 → 조건부 렌더링/검증 요구사항. 렌더와 검증의 단일 진실(순수 함수).

import { ALIMTALK_EVENT_ID_PLACEHOLDER } from '../../constants/service/app/alimtalkConstants';
import {
  ALIMTALK_ACTION_TYPE,
  ALIMTALK_TEMPLATE_MODE,
  AlimtalkButton,
  AlimtalkTemplate,
} from '../../types/alimtalk/template';
import { FieldRequirements } from '../../types/alimtalk/form';

/** 버튼의 URL/scheme 4종 중 {{eventId}} 플레이스홀더 포함 여부 */
const buttonsContainEventId = (buttons: AlimtalkButton[]): boolean =>
  buttons.some((button) =>
    [button.url_mobile, button.url_pc, button.scheme_ios, button.scheme_android].some((url) =>
      url?.includes(ALIMTALK_EVENT_ID_PLACEHOLDER),
    ),
  );

export const deriveFieldRequirements = (template: AlimtalkTemplate): FieldRequirements => {
  const isCsv = template.mode === ALIMTALK_TEMPLATE_MODE.CSV;
  const { actionType } = template;
  // 백엔드 collectTemplateVars 미러 — {{eventId}}는 버튼 URL뿐 아니라 메시지 본문에 있어도 필수.
  // 본문만 검사에서 빠지면 미치환 {{eventId}}가 그대로 발송된다.
  const hasEventId =
    buttonsContainEventId(template.buttons) ||
    Boolean(template.messageTemplate?.includes(ALIMTALK_EVENT_ID_PLACEHOLDER));
  // 백엔드 isExpireCoupon 미러 — mode까지 함께 본다.
  // (actionType만 보면 CSV 모드 데이터에 EXPIRE가 섞였을 때 백엔드는 CSV 필수인데 프론트는 생략 → 400)
  const isExpireCoupon = !isCsv && actionType === ALIMTALK_ACTION_TYPE.EXPIRE_COUPON;

  return {
    needsCsvVariables: isCsv,
    // 백엔드 validateParamsForTemplate 미러(#4841) — EXPIRE는 쿠폰 보유자 전원이 자동 대상이라 CSV 미사용(보내면 400)
    needsCsvUpload: !isExpireCoupon,
    needsCouponList: !isCsv && actionType !== null,
    needsValidityDates:
      actionType === ALIMTALK_ACTION_TYPE.ISSUE_COUPON_ONLY ||
      actionType === ALIMTALK_ACTION_TYPE.ISSUE_COUPON,
    needsAlimtalkCouponId: actionType === ALIMTALK_ACTION_TYPE.ISSUE_COUPON,
    // 백엔드 requiresEventId는 mode 무관 선검사이고, CSV 모드 거부 목록에 eventId는 없다(쿠폰 파라미터만 거부) —
    // 즉 {{eventId}}가 있으면 CSV 모드에서도 eventId 필수. mode 무관하게 hasEventId로 판정.
    needsEventId: hasEventId,
    isExpireReorderable: isExpireCoupon,
    canTestSend: template.templateCode !== null,
  };
};
